import { MapToContext } from '@utils/objectWithDefault'

export default class CountryCurrency {
  constructor (a) {
    const defaultDataModel = {
      Id: { val: 0, type: Number },
      CountryISO2: { val: '', type: String },
      ZoneTypeId: { val: 0, type: Number },
      Name: { val: '', type: String },
      CurrencyName: { val: '', type: String },
      CurrencyCode: { val: '', type: String },
      CurrencySymbol: { val: '', type: String }
    }

    MapToContext(this, defaultDataModel, a)
  }
}

export class AllCountryCurrency {
  constructor (countryCurrenciesData) {
    const defaultCountryCurrencies = {
      options: { val: [], type: Array, subType: CountryCurrency }
    }

    MapToContext(this, defaultCountryCurrencies, countryCurrenciesData)
  }
}
